import { Navigate, useParams } from '@user-management/router';

export default function PermissionDetailsPage() {
  const { appRoleId } = useParams('/roles-and-permissions/:appRoleId/permissions');

  return (
    <Navigate
      to='/roles-and-permissions/:appRoleId/permissions/:app'
      params={{ appRoleId, app: 'exam-management' }}
      replace
    />
  );
}
